<div class="mb-4">
  <app-card [titleKey]="title()">
    <app-title-name-form [formGroup]="formGroup()" />
  </app-card>
</div>
